export enum Roles {
  Member = "Member",
  Admin = "Admin",
  Guest = "Guest",
}
